if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this.isDragging = false;
      this.startX = 0;
      this.currentTranslate = 0;
      this.animationOffset = 0;
      this.manualOffset = 0;
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
      this.setupDrag();
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }

    setupDrag() {
      this.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        this.startX = e.clientX;
        this.classList.add('is-dragging');
        
        // Get current animation position
        const promos = this.querySelectorAll('.m-promotion');
        promos.forEach(promo => {
          const computed = window.getComputedStyle(promo);
          const matrix = new DOMMatrix(computed.transform);
          this.animationOffset = matrix.m41;
          promo.style.animation = 'none';
        });
      });

      this.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        
        const diff = e.clientX - this.startX;
        this.currentTranslate = this.animationOffset + diff;
        
        this.querySelectorAll('.m-promotion').forEach(promo => {
          promo.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;
        });
      });

      const endDrag = () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.classList.remove('is-dragging');
        
        // Store the final position
        this.manualOffset = this.currentTranslate;
        
        // Keep the transform in place and resume animation from this point
        this.querySelectorAll('.m-promotion').forEach(promo => {
          promo.style.transform = `translate3d(${this.manualOffset}px, 0, 0)`;
        });
      };

      this.addEventListener('mouseup', endDrag);
      this.addEventListener('mouseleave', endDrag);

      // Touch events
      this.addEventListener('touchstart', (e) => {
        this.isDragging = true;
        this.startX = e.touches[0].clientX;
        this.classList.add('is-dragging');
        
        const promos = this.querySelectorAll('.m-promotion');
        promos.forEach(promo => {
          const computed = window.getComputedStyle(promo);
          const matrix = new DOMMatrix(computed.transform);
          this.animationOffset = matrix.m41;
          promo.style.animation = 'none';
        });
      }, { passive: true });

      this.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        
        const diff = e.touches[0].clientX - this.startX;
        this.currentTranslate = this.animationOffset + diff;
        
        this.querySelectorAll('.m-promotion').forEach(promo => {
          promo.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;
        });
      }, { passive: true });

      this.addEventListener('touchend', endDrag);

      // Prevent image drag
      this.querySelectorAll('img, a').forEach(el => {
        el.addEventListener('dragstart', (e) => e.preventDefault());
      });
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}